import React, { useState, useEffect, useRef } from "react";

export default function Video(props) {
  const [skipped, setSkipped] = useState(false);
  const [showArrow, setShowArrow] = useState(false);
  const currentSlide = props.currentSlide;
  const videoRef = useRef();

  const width= window.innerWidth;

  useEffect(() => {
    const width= window.innerWidth;
  }, []);

  useEffect(() => {
    if (currentSlide.fullScreenVideo) {
      if (videoRef.current) {
        setShowArrow(true);
        setSkipped(false);
        videoRef.current.muted = false;
        videoRef.current.volume = 1;
        videoRef.current.play();
        //console.log("playing video");
      }
    }
  }, [currentSlide]);

  if (!currentSlide) {
    return null;
  }

  const BASE_URL = currentSlide.fullScreenVideo
  const URL = `${BASE_URL}`
  
  return (
    <div
      id={"static-video"}
      style={{
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "black",
        alignItems: "center",
        opacity: currentSlide.fullScreenVideo ? "1" : "0",
        pointerEvents: showArrow ? "auto" : "none",
        //In case it's in the mobile app
        zIndex:
          currentSlide.fullScreenVideo && props.isMobile && !skipped? 1000: 30,
        width: "100vw",
        height: "100vh",
        WebkitTransition: "opacity 0.5s",
      }}>
      {currentSlide.fullScreenVideo ? (
        <video
          controls={props.isMobile}
          ref={videoRef}
          preload="auto"
          loop={true}
          muted = {true}
          defaultMuted
          autoPlay={true}
          playsInline={true}
          width={width}
          zIndex="1000"
          ////playsInline
          type="video/mp4"
          src={URL}
          onLoad={() => {
            //console.log("loading video");
          }}
          onEnded={() => {
            //console.log("video ended");
            setSkipped(true);
            setShowArrow(false);
          }}
        />
      ) : null}
      {props.isMobile && showArrow && (
        <div
          id="arrow-div"
          onClick={() => {
            //console.log("skip clicked");
            setSkipped(true);
            setShowArrow(false);
          }}
          style={{
            position: "fixed",
            display: "flex",
            justifyContent: "center",
            bottom: "10px",
            height: "20vh",
            width: "100vw",
          }}
        >
          <p
            style={{
              color: "white",
              padding: `3rem`,
            }}
          >
            Skip to Text
          </p>
        </div>
      )}
    </div>
  );
}
